var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketFirstUnlockedBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463.45087,
    height: 200,
    viewBox: "0 0 428.86491 200",
    fill: "none",
    id: "svg12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 69.634283,31.999998 H 431.07328 c 7.147,0 11.987,7.2792 9.222,13.869 l -18.837,44.8929 c -2.076,4.9497 -2.076,10.526102 0,15.476102 l 18.837,44.893 c 2.765,6.59 -2.075,13.869 -9.222,13.869 H 34.634283 c -5.52284,0 -10,-4.477 -10,-10 V 76.999998 c 0,-24.8528 20.1472,-45 45,-45 z",
    fill: "#ffffff",
    stroke: "#FFF171",
    strokeWidth: 10,
    id: "path2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 183.63428,170 h 244 v 15 c 0,8.284 -6.716,15 -15,15 h -118.576 c -1.628,0 -3.249,-0.221 -4.819,-0.657 z",
    fill: "#f83600",
    id: "path4",
    style: {
      fill: "#FFF171",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 227.63428,26.999998 h 200 v -12 C 427.63428,6.7157281 420.91828,0 412.63428,0 h -99.629 c -1.902,0 -3.792,0.30135409 -5.599,0.89285109 z",
    fill: "#f83600",
    id: "path6",
    style: {
      fill: "#FFF171",
      fillOpacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketFirstUnlockedBox);
export default __webpack_public_path__ + "static/media/rocketFirstUnlockedBox.cc4daa11a4f976883008089bb4b49a85.svg";
export { ForwardRef as ReactComponent };